import React, { useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
    dashboardActions,
    visualizationSelector,
} from '../../../../store/slices/dashboardSlice/dashboardSlice';

export const useVisualizationBlock = () => {
    const [prevImageData, setPrevImageData] = useState({
        currentIndex: 0,
        currentUrl: '',
        mimeType: '',
    });

    // @ts-ignore
    const { is_customer, can_show_financial_info } = useSelector((state) => state.dashboardReducer);
    const visualizations = useSelector(visualizationSelector.selectAll);
    const imagesSrc = visualizations.map((visualization) => visualization.original_url);
    const mediaData = visualizations.map((visualization) => ({
        url: visualization.original_url,
        mimeType: visualization.mime_type || 'image/*',
    }));
    const dispatch = useDispatch();

    const onEditVisualization = useCallback(() => {
        dispatch(dashboardActions.onModalMode('visualization'));
    }, []);

    const setCurrentIndex = useCallback(
        (index: number) => {
            setPrevImageData((prevState) => ({ ...prevState, currentIndex: index }));
        },
        [prevImageData]
    );
    const setCurrentUrl = useCallback(
        (url: string) => {
            setPrevImageData((prevState) => ({ ...prevState, currentUrl: url }));
        },
        [prevImageData]
    );
    const setCurrentMimeType = useCallback(
        (mimeType: string) => {
            setPrevImageData((prevState) => ({ ...prevState, mimeType }));
        },
        [prevImageData]
    );
    const onHideModal = useCallback(() => {
        setPrevImageData({
            currentIndex: 0,
            currentUrl: '',
            mimeType: '',
        });
    }, []);
    const onShowPrevImage = useCallback(
        (currentIndex: number, currentUrl: string, e: React.SyntheticEvent) => {
            e.stopPropagation();
            setPrevImageData({
                currentIndex,
                currentUrl,
                mimeType: 'image/*',
            });
        },
        []
    );
    return {
        onEditVisualization,
        imagesSrc,
        mediaData,
        prevImageData,
        setCurrentIndex,
        setCurrentUrl,
        setCurrentMimeType,
        onHideModal,
        onShowPrevImage,
        is_customer,
        can_show_financial_info,
    };
};
